export let playerPool;

WL.registerComponent('physx-pool', {
}, {
    start: function() {
        playerPool = this;
        this.inactiveEntities = [];
        this.activeEntities = [];
        let children = this.object.children;
        for(let i = 0; i < children.length; i++) {
            const child = children[i];
            this.inactiveEntities.push(child);
            if(child.onDeactivateCallbacks) {
                child.onDeactivateCallbacks.push(() => {
                    this.returnEntity(child);
                })
            }
        }
    },
    getEntity: function() {
        if(this.inactiveEntities.length) {
            const entity = this.inactiveEntities.pop();
            this.activeEntities.push(entity);
            return entity;
        } else {
            console.error('physx-pool: All pool entities are active. Please create more elements before this script runs.');
            return null;
        }
    },
    returnEntity: function(entity) {
        let index = this.activeEntities.indexOf(entity);
        if(index !== -1 && !this.inactiveEntities.includes(entity)) {
            entity.parent = this.object;
            entity.resetTranslationRotation();
            this.activeEntities.splice(index, 1);
            this.inactiveEntities.push(entity)
        } else {
            console.error('physx-pool: You can not return an entity that is not part of the active pool.');
        }
    },
});
